import {
  Box,
  Button,
  Drawer,
  Group,
  Text,
  ActionIcon,
  Indicator,
  Affix,
  Transition,
} from "@mantine/core";
import { IconArrowLeft, IconMessage, IconX } from "@tabler/icons-react";
import AssessmentChatSidebar from "./assessment/AssessmentChatSidebar";

export function CollaborationChatDrawer({
  opened,
  onClose,
  matchId,
  chatOpen,
  collaborationReadOnly,
  currentUserId,
  previewLocked,
  backAriaLabel = "Back",
}: {
  opened: boolean;
  onClose: () => void;
  matchId: string;
  chatOpen: boolean;
  collaborationReadOnly?: boolean;
  currentUserId: string | undefined;
  previewLocked: boolean;
  backAriaLabel?: string;
}) {
  const NAVY = "var(--mantine-color-primary-7)";
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="md"
      withCloseButton={false}
      padding={0}
      closeOnEscape
      closeOnClickOutside
      trapFocus
      zIndex={9999}
      lockScroll
      styles={{
        root: { zIndex: 9999 },
        inner: { zIndex: 9999 },
        overlay: { zIndex: 9998 },
        body: { padding: 0, display: "flex", flexDirection: "column", height: "100%", minHeight: 0 },
        content: { display: "flex", flexDirection: "column", backgroundColor: "#ffffff", zIndex: 9999 },
        header: { display: "none" },
      }}
    >
      <Box
        style={{
          position: "sticky",
          top: 0,
          zIndex: 5,
          backgroundColor: NAVY,
          color: "#ffffff",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          flexShrink: 0,
        }}
      >
        <Group justify="space-between" align="center" wrap="nowrap" px="md" py="sm">
          <Group gap="sm" align="center" wrap="nowrap" style={{ minWidth: 0 }}>
            <ActionIcon
              size={40}
              radius="md"
              onClick={onClose}
              aria-label={backAriaLabel}
              styles={{
                root: {
                  backgroundColor: "rgba(255,255,255,0.16)",
                  color: "#ffffff",
                  border: "1px solid rgba(255,255,255,0.2)",
                },
              }}
            >
              <IconArrowLeft size={22} stroke={2} />
            </ActionIcon>
            <Box style={{ minWidth: 0 }}>
              <Text
                fw={700}
                fz="md"
                c="white"
                lh={1.2}
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              >
                Collaboration Chat
              </Text>
            </Box>
          </Group>
          <ActionIcon
            size={40}
            radius="md"
            onClick={onClose}
            aria-label="Close chat"
            styles={{
              root: {
                backgroundColor: "transparent",
                color: "#ffffff",
              },
            }}
          >
            <IconX size={24} stroke={2} />
          </ActionIcon>
        </Group>
      </Box>

      <Box style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <AssessmentChatSidebar
          matchId={matchId}
          chatOpen={chatOpen}
          collaborationReadOnly={collaborationReadOnly}
          currentUserId={currentUserId}
          previewLocked={previewLocked}
          hideHeader
        />
      </Box>
    </Drawer>
  );
}

export function CollaborationChatFab({
  onClick,
  disabled,
  locked,
}: {
  onClick: () => void;
  disabled: boolean;
  locked: boolean;
}) {
  return (
    <Affix position={{ bottom: 20, right: 20 }} zIndex={50}>
      <Transition transition="slide-up" mounted={!disabled || locked}>
        {(styles) => (
          <Indicator
            color={locked ? "yellow" : "green"}
            offset={6}
            size={10}
            disabled={disabled}
            processing={!disabled}
            styles={{ root: { ...styles } }}
          >
            <Button
              radius="xl"
              size="md"
              leftSection={<IconMessage size={18} />}
              onClick={onClick}
              disabled={disabled && !locked}
              styles={{
                root: {
                  backgroundColor: "var(--mantine-color-primary-7)",
                  boxShadow: "0 8px 20px rgba(4, 48, 92, 0.25)",
                },
              }}
            >
              Chat
            </Button>
          </Indicator>
        )}
      </Transition>
    </Affix>
  );
}
